import React, { Component } from "react";
import styled from "styled-components";
import { default as Integrador2 } from "../../../images/pdv3.png";
export default class Project00 extends Component {
  render() {
    return (
      <Align id="top">
        <Title>Sistema de vendas de produtos (PDV)</Title>
        <Container>
          <Right>
            <div>
              <Subtitle>
                Desenvolvimento de um Aplicativo Desktop Exclusivo para a
                empresa Gestão do preço
              </Subtitle>
              <Text>
                Um projeto que visa criar um sistema de vendas (PDV) onde é
                possível através da venda de produtos contabilizar gastos e
                despesas, foi desenvolvido utilizando a combinação das
                tecnologias Electron/ReactJS/NodeJS
                <Link href="/#">
                  <br></br>Mais informações aqui
                </Link>
              </Text>
            </div>
            <ImagePC src={Integrador2} height={350} alt="projeto2"></ImagePC>
          </Right>
        </Container>
      </Align>
    );
  }
}

const Align = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Container = styled.div`
  display: flex;
  text-align: center;
  align-items: center;

  @media (max-width: 1250px) {
    flex-direction: column;
  }
`;
const Right = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

const ImagePC = styled.img`
  border: 1px solid #000;
  width: 113vh;
  @media (max-width: 800px) {
    display: none;
  }
`;
const Title = styled.h2`
  margin: 15vh 0 7vh 0;
`;
const Subtitle = styled.h3`
  margin: 0;
`;
const Text = styled.p``;
const Link = styled.a`
  font-weight: bold;
  color: #000;
  margin: 0 auto;
`;
